import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

type Props = {
  icon: IconDefinition;
  onClick: () => void;
  ariaLabel: string;
};

export const MDActionIcon = ({ icon, onClick, ariaLabel }: Props) => (
  <button
    type="button"
    aria-label={ariaLabel}
    onClick={onClick}
    style={{
      display: 'flex',
      width: 42,
      height: 42,
      padding: 5.463,
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: 5.463,
      borderRadius: '50%',
      border: 'none',
      background: '#F5F6FA',
      boxShadow: 'none',
      cursor: 'pointer',
      outline: 'none',
    }}
    onFocus={(e) => e.currentTarget.blur()}
  >
    <FontAwesomeIcon
      icon={icon}
      style={{
        color: 'var(--primary-P-80, #5F1ECC)',
        fontFamily: '"Font Awesome 6 Pro"',
        fontSize: 12,
        fontStyle: 'normal',
        fontWeight: 900,
        lineHeight: 'normal',
      }}
    />
  </button>
);
